import { Table } from "./types";

const defaultState = {
    isEditingCell: false,
    columnState: [],
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Table.START_CELL_EDIT:
            return {
                ...state,
                isEditingCell: true,
            };

        case Table.STOP_CELL_EDIT:
            return {
                ...state,
                isEditingCell: false,
            };
        case Table.SET_COLUMN_STATE:
            return {
                ...state,
                columnState: action.columnState,
            };
        default:
            return state;
    }
};
